import a from "./getDetailedProductVariantStock.mjs";
import i from "./isDetailedProductOutletStockOutOfStock.mjs";
function u(t, o) {
  const r = a(t, o);
  return i(r);
}
export {
  u as default
};
